export const AUTH_TOKEN = 'apm-token';
